import React from 'react';

export const ReviewContainerContext = React.createContext({
  index: null,
  dto: null,
  length: null,
  onSubmit: null,
  onNext: null,
  onPrev: null,
  showNext: false,
  showPrev: false,
});
